import { addError } from '@infra/datadog/tracking';
import { DeviceIdService } from '@services/DeviceIdService';
import createClient from 'openapi-fetch';
import type { paths, components } from '@api/fast-games/generated';

import { ApiError } from '@libs/errors';

import { AuthService } from '@features/auth/services/AuthService';

const NAME = 'FastGamesApi';

/*
  ____,-------------------------------,____
  \   |          Http Client          |   /
  /___|-------------------------------|___\
*/

export { components, paths };

function getAccessKey() {
  return AuthService.instance.accessToken ?? '';
}

const api = createClient<paths>({
  baseUrl: __RUNTIME.fastgamesApi,
});

api.use({
  async onRequest({ request }) {
    request.headers.set('X-Device-Id', DeviceIdService.instance.id);
    request.headers.set('Authorization', `Bearer ${getAccessKey()}`);
    return request;
  },

  async onResponse({ response }) {
    if (response.status === 401) {
      AuthService.instance.deleteTokens();
    }

    if (response.status >= 400) {
      const err = await ApiError.fromResponse(NAME, response);

      addError(err);
      throw err;
    }
    return undefined;
  },

  onError({ error, request }) {
    const err = ApiError.fromRequestError(NAME, request, error);

    addError(err);
    throw err;
  },
});

const { GET, POST, DELETE } = api;
export { GET, POST, DELETE };
